var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"custom-class":"image-modal","width":"unset","active":_vm.active,"can-cancel":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('ImageAsset',{attrs:{"photo":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }